export const BASE_URL = "https://study-material-app.onrender.com"